// extracted by mini-css-extract-plugin
export default {"card":"VideoPokerCard_card__FdaHN","title":"VideoPokerCard_title__ItpvR","playNow":"VideoPokerCard_playNow__zyzRl","screenshot":"VideoPokerCard_screenshot__hx9BP"};